var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.user.hasRoles.includes("Archived Teacher")
        ? _c("v-banner", { attrs: { color: "soli-status-red" } }, [
            _c("div", { staticClass: "white--text flex justify-center" }, [
              _vm._v("\n            This teacher has been archived\n        "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        { directives: [{ name: "masonry", rawName: "v-masonry" }] },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c(
                "v-card",
                { staticClass: "soli-round" },
                [
                  _c(
                    "v-container",
                    [
                      _c("v-card-title", { staticClass: "soli-grey" }, [
                        _vm._v(
                          "\n                        Settings\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-subtitle",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "soli-round soli-blue-text",
                              attrs: { "x-small": "", outlined: "" },
                              on: {
                                click: function ($event) {
                                  _vm.isTeacher
                                    ? (_vm.archiveTeacherWarning = true)
                                    : (_vm.setTeacherConfirm = true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.isTeacher
                                    ? "Archive Teacher"
                                    : _vm.isArchivedTeacher
                                    ? "Unarchive Teacher"
                                    : "Hire as Teacher"
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "soli-round soli-blue-text",
                              attrs: { "x-small": "", outlined: "" },
                              on: {
                                click: function ($event) {
                                  _vm.isStaff
                                    ? (_vm.archiveStaffWarning = true)
                                    : (_vm.setStaffConfirm = true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.isStaff
                                    ? "Archive Staff"
                                    : _vm.isArchivedStaff
                                    ? "Unarchive Staff"
                                    : "Hire as Staff"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-form",
                                    { ref: "form" },
                                    [
                                      _vm.isStaff || _vm.isArchivedStaff
                                        ? _c("StaffRoles", {
                                            attrs: {
                                              disabled: _vm.isArchivedStaff,
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.staff_role,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "staff_role",
                                                  $$v
                                                )
                                              },
                                              expression: "form.staff_role",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isStaff || _vm.isArchivedStaff
                                        ? _c("SoliDate", {
                                            attrs: {
                                              label: "Staff Start Date",
                                              error: _vm.errors.starts_at,
                                              rules: _vm.rules.input,
                                              noLimit: "",
                                            },
                                            model: {
                                              value: _vm.form.staffStartDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "staffStartDate",
                                                  $$v
                                                )
                                              },
                                              expression: "form.staffStartDate",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isTeacher || _vm.isArchivedTeacher
                                        ? _c(
                                            "div",
                                            [
                                              _c("TeacherCertification", {
                                                attrs: {
                                                  disabled:
                                                    _vm.isArchivedTeacher,
                                                  alert:
                                                    _vm.isTeacher &&
                                                    !_vm.user
                                                      .certification_level,
                                                },
                                                model: {
                                                  value:
                                                    _vm.form
                                                      .certification_level,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "certification_level",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "\n                                                form.certification_level\n                                            ",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.isTeacher ||
                                              _vm.isArchivedTeacher
                                                ? _c("SoliDate", {
                                                    attrs: {
                                                      label:
                                                        "Teacher Start Date",
                                                      error:
                                                        _vm.errors.starts_at,
                                                      rules: _vm.rules.input,
                                                      noLimit: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form
                                                          .teacherStartDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "teacherStartDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.teacherStartDate",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("v-switch", {
                                                staticClass: "mt-0",
                                                attrs: {
                                                  disabled:
                                                    _vm.isArchivedTeacher,
                                                  dense: "",
                                                  label:
                                                    "Can auto-assign online availability",
                                                },
                                                model: {
                                                  value: _vm.form.autoAssign,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "autoAssign",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.autoAssign",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isTeacher || _vm.isStaff
                                        ? _c("SoliText", {
                                            attrs: {
                                              "error-messages":
                                                _vm.errors.payroll_employee_id,
                                              number: "",
                                              icon: "badge",
                                              label: "Payroll Employee ID",
                                              placeholder:
                                                "Payroll Employee ID (if applicable)",
                                            },
                                            model: {
                                              value:
                                                _vm.form.payroll_employee_id,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "payroll_employee_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.payroll_employee_id",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasWorked
            ? _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("StaffPayRates", {
                    attrs: {
                      user: _vm.user,
                      payRates: _vm.payRates,
                      rules: _vm.rules,
                      isStaff: _vm.isStaff,
                      isTeacher: _vm.isTeacher,
                      errors: _vm.errors,
                    },
                    on: {
                      "hook:updated": function ($event) {
                        return _vm.redrawVueMasonry()
                      },
                      success: function ($event) {
                        return _vm.$emit("success")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTeacher || _vm.isArchivedTeacher
            ? _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "soli-grey" },
                            [
                              _vm._v("Instruments"),
                              _vm.missingInstruments
                                ? _c(
                                    "v-icon",
                                    { attrs: { right: "", color: "error" } },
                                    [_vm._v("error_outline")]
                                  )
                                : _vm._e(),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showInstrumentHelp = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("help")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-subtitle",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "soli-round soli-blue-text",
                                  attrs: {
                                    "x-small": "",
                                    outlined: "",
                                    disabled:
                                      !_vm.user.hasPermissions.includes("Work"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;[(_vm.showInstrumentForm = true)]
                                    },
                                  },
                                },
                                [_vm._v("Add Instrument")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            staticStyle: {
                              cursor: "pointer",
                              "white-space": "nowrap",
                            },
                            attrs: {
                              headers: _vm.instrumentHeaders,
                              items: _vm.instruments,
                              "hide-default-footer": "",
                              "mobile-breakpoint": "0",
                              "no-data-text": "No instruments available",
                            },
                            on: { "click:row": _vm.editInstrument },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.name`,
                                  fn: function ({ item }) {
                                    return [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(item.name) +
                                          "\n                        "
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.ageRanges`,
                                  fn: function ({ item }) {
                                    return _vm._l(
                                      _vm.getAgeRange(item),
                                      function (range) {
                                        return _c(
                                          "v-chip",
                                          {
                                            key: range,
                                            staticClass:
                                              "soli-status-group white--text ma-05",
                                            attrs: { pill: "", small: "" },
                                          },
                                          [_vm._v(_vm._s(range))]
                                        )
                                      }
                                    )
                                  },
                                },
                                {
                                  key: `item.skillLevels`,
                                  fn: function ({ item }) {
                                    return _vm._l(
                                      _vm.getSkillLevel(item),
                                      function (level) {
                                        return _c(
                                          "v-chip",
                                          {
                                            key: level,
                                            staticClass:
                                              "soli-status-blue white--text ma-05",
                                            attrs: { pill: "", small: "" },
                                          },
                                          [_vm._v(_vm._s(level))]
                                        )
                                      }
                                    )
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstrumentHelp
            ? _c("SoliResponsiveDialog", {
                attrs: { title: "About Ages and Levels" },
                on: {
                  reset: function ($event) {
                    _vm.showInstrumentHelp = false
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("v-card-text", { staticClass: "pt-0" }, [
                            _c("ul", { staticClass: "inside-list" }, [
                              _c("li", [
                                _vm._v(
                                  "\n                            A teacher who passes the Beginner level Audition\n                            can teach: young beginners ages 5-7\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                            A teacher who passes the Intermediate level\n                            Audition can teach: beginner students of all\n                            ages and Labs\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                            A teacher who passes the Advanced level Audition\n                            can teach: Labs, beginner to advanced students\n                            of all ages\n                        "
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3097436471
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isTeacher || _vm.isArchivedTeacher
            ? _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "pb-0 soli-grey",
                              staticStyle: {
                                "max-height": "64px",
                                "z-index": "100",
                                position: "relative",
                              },
                            },
                            [
                              _vm._v("\n                        Stats "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showStatsHelp = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("help")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tabs",
                            {
                              staticClass: "custom-tabs px-4",
                              model: {
                                value: _vm.statsTab,
                                callback: function ($$v) {
                                  _vm.statsTab = $$v
                                },
                                expression: "statsTab",
                              },
                            },
                            _vm._l(_vm.teacherStats, function (stat) {
                              return _c(
                                "v-tab",
                                {
                                  key: stat.title,
                                  attrs: { disabled: stat.disabled },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(stat.title) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tabs-items",
                            {
                              attrs: { touchless: "" },
                              model: {
                                value: _vm.statsTab,
                                callback: function ($$v) {
                                  _vm.statsTab = $$v
                                },
                                expression: "statsTab",
                              },
                            },
                            _vm._l(_vm.teacherStats, function (stat, idx) {
                              return _c(
                                "v-tab-item",
                                {
                                  key: stat.title,
                                  class: {
                                    "stat-with-options": stat.hasOptions,
                                  },
                                  staticStyle: { "min-height": "304px" },
                                  attrs: { transition: false },
                                },
                                [
                                  idx == _vm.statsTab
                                    ? _c("TeacherStat", {
                                        staticClass:
                                          "animate__animated animate__fadeIn",
                                        attrs: {
                                          teacher: _vm.user,
                                          showStatsHelp: _vm.showStatsHelp,
                                          title: stat.title,
                                          defaultOption: stat.defaultOption,
                                          help: stat.help,
                                        },
                                        on: {
                                          rendered: _vm.redrawVueMasonry,
                                          reset: function ($event) {
                                            _vm.closeModal(
                                              () => (_vm.showStatsHelp = false)
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTeacher || _vm.isArchivedTeacher
            ? _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v(
                              "\n                        Annual Reviews\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-card-subtitle",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "soli-round soli-blue-text",
                                  attrs: { "x-small": "", outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.$refs.review.dialog = true
                                    },
                                  },
                                },
                                [_vm._v("New Review")]
                              ),
                            ],
                            1
                          ),
                          _c("TeacherReview", {
                            ref: "review",
                            attrs: {
                              teacher: _vm.user,
                              annualReviews: _vm.annualReviews,
                              errors: _vm.errors,
                            },
                            on: {
                              success: function ($event) {
                                return _vm.$emit("success")
                              },
                              reset: function ($event) {
                                return _vm.$emit("reset")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTeacher || _vm.isArchivedTeacher
            ? _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v(
                              "\n                        Feedback\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-card-subtitle",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "soli-round soli-blue-text",
                                  attrs: { "x-small": "", outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.$refs.feedback.dialog = true
                                    },
                                  },
                                },
                                [_vm._v("Add Feedback")]
                              ),
                            ],
                            1
                          ),
                          _c("TeacherFeedback", {
                            ref: "feedback",
                            attrs: {
                              teacher: _vm.user,
                              feedback: _vm.feedback,
                              errors: _vm.errors,
                            },
                            on: {
                              success: function ($event) {
                                return _vm.$emit("success")
                              },
                              reset: function ($event) {
                                return _vm.$emit("reset")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstrumentForm
            ? _c("SoliForm", {
                ref: "instrumentForm",
                attrs: {
                  title: `${
                    _vm.showInstrumentForm.id
                      ? `Edit ${_vm.showInstrumentForm.name} Details`
                      : "Add Instrument"
                  }`,
                  text: "Save",
                  icon: "save",
                  mobileScroll: "",
                  saveChanges: _vm.editInstrumentForm,
                  persistent: "",
                },
                on: {
                  reset: function ($event) {
                    return _vm.reset()
                  },
                  submit: function ($event) {
                    return _vm.saveInstrument(false)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          !_vm.showInstrumentForm.id
                            ? _c("SoliInstruments", {
                                attrs: {
                                  multiple: false,
                                  rules: _vm.rules.select,
                                  hideIcon: true,
                                  returnObject: false,
                                  filter: _vm.instruments.map((e) => e.id),
                                },
                                model: {
                                  value: _vm.instrumentForm.id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.instrumentForm, "id", $$v)
                                  },
                                  expression: "instrumentForm.id",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("InstrumentSkillLevel", {
                            attrs: { rules: _vm.rules.input },
                            model: {
                              value: _vm.instrumentForm.skillLevels,
                              callback: function ($$v) {
                                _vm.$set(_vm.instrumentForm, "skillLevels", $$v)
                              },
                              expression: "instrumentForm.skillLevels",
                            },
                          }),
                          _vm._v(" "),
                          _c("InstrumentAgeRange", {
                            attrs: { rules: _vm.rules.input },
                            model: {
                              value: _vm.instrumentForm.ageRanges,
                              callback: function ($$v) {
                                _vm.$set(_vm.instrumentForm, "ageRanges", $$v)
                              },
                              expression: "instrumentForm.ageRanges",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "cancelBtn",
                      fn: function (attrs) {
                        return [
                          !_vm.editInstrumentForm && _vm.showInstrumentForm.id
                            ? _c(
                                "SoliBtn",
                                _vm._b(
                                  {
                                    staticClass: "mt-3",
                                    attrs: {
                                      text: "Delete",
                                      icon: "delete",
                                      color: "soli-status-red",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveInstrument(true)
                                      },
                                    },
                                  },
                                  "SoliBtn",
                                  attrs,
                                  false
                                )
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2890157133
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.archiveTeacherWarning
            ? _c("SoliChoice", {
                attrs: {
                  title: "Are you sure?",
                  subtitle: `This will remove ${_vm.user.first_name} from your teacher list. ${_vm.user.first_name} will no longer be able to access teacher-specific functionality. Any pending lessons will be paid at the end of this period. You will still need to remove any availability and lessons from ${_vm.user.first_name}'s schedule.`,
                  button1: "Confirm",
                  button2: "Nevermind",
                },
                on: {
                  option1: function ($event) {
                    return _vm.setTeacherStatus(false)
                  },
                  reset: function ($event) {
                    _vm.closeModal(() => (_vm.archiveTeacherWarning = false))
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.setTeacherConfirm
            ? _c("SoliChoice", {
                attrs: {
                  title: "Are you sure?",
                  subtitle: `This will add ${_vm.user.first_name} to your teacher list. ${_vm.user.first_name} will gain access teacher-specific functionality.`,
                  button1: "Confirm",
                  button2: "Nevermind",
                },
                on: {
                  option1: function ($event) {
                    return _vm.setTeacherStatus(true)
                  },
                  reset: function ($event) {
                    _vm.closeModal(() => (_vm.setTeacherConfirm = false))
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.archiveStaffWarning
            ? _c("SoliChoice", {
                attrs: {
                  title: "Are you sure?",
                  subtitle: `This will remove ${_vm.user.first_name} from your staff list. ${_vm.user.first_name} will no longer be able to access staff-specific functionality.`,
                  button1: "Confirm",
                  button2: "Nevermind",
                },
                on: {
                  option1: function ($event) {
                    return _vm.setStaffStatus(false)
                  },
                  reset: function ($event) {
                    _vm.closeModal(() => (_vm.archiveStaffWarning = false))
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.setStaffConfirm
            ? _c("SoliChoice", {
                attrs: {
                  title: "Are you sure?",
                  subtitle: `This will add ${_vm.user.first_name} to your staff list. ${_vm.user.first_name} will gain access staff-specific functionality.`,
                  button1: "Confirm",
                  button2: "Nevermind",
                },
                on: {
                  option1: function ($event) {
                    return _vm.setStaffStatus(true)
                  },
                  reset: function ($event) {
                    _vm.closeModal(() => (_vm.setStaffConfirm = false))
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }